<div *ngIf="isLoaderNeeded()" class="loader-wrapper">
  <div class="loader"></div>
</div>
